import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpHeadshot = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element

    commonScripts.util.animationTranslate(this)

    const isFiltered = _.component.classList.contains('cmp-headshot--filtered')
    if (isFiltered) {
      const panels = _.component.querySelectorAll('.cmp-headshot__panel')
      panels.forEach(function (panel) {
        if (panel.classList.contains('first')) {
          panel.style.display = 'block'
        }
      })

      const dropdowns = _.component.querySelectorAll('select')
      dropdowns.forEach(function (dropdown) {
        dropdown.addEventListener('change', function () {
          panels.forEach(panel => {
            panel.style.display = 'none'
          })
          const activePanel = document.getElementById(this.value)
          activePanel.style.display = this.value ? 'block' : 'none'
        }, false)
      })
    }

    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselDiv = _.component.querySelectorAll('.glide')
      if (carouselDiv) {
        for (let i = 0; i < carouselDiv.length; i++) {
          const autoplay = _.component.getAttribute('data-autoplay')
          let loop = _.component.getAttribute('data-loop')
          loop = loop ? loop.toLowerCase() : loop
          const options = {}
          options.gap = 0
          options.type = (loop === 'true') ? 'carousel' : 'slider'
          options.autoplay = (isNaN(autoplay) || autoplay === '0') ? false : (autoplay * 1000)
          options.rewind = false          
          let slideCount = carouselDiv[i].querySelectorAll('.glide__slide');
          if (slideCount.length > 1) {
            new Glide(carouselDiv[i], options).mount()
          } else{
            let bullets = carouselDiv[i].querySelector('.glide__bullets');
            if(bullets){
                bullets.style.display = 'none'
            }
          }
        }
      }
    }
  }
}

export default cmpHeadshot
